import { projectManagementApi } from '@/includes/projectManagementApi';

const pmImpactAnalysisService = {
  async getProjectImpactAnalysis(projectId, { weeks = 8 } = {}) {
    const response = await projectManagementApi.get(
      `/projects/${projectId}/analytics/impact-analysis`,
      { params: { weeks } },
    );
    return response.data;
  },
};

export default pmImpactAnalysisService;
